import script from "./WebPay.vue?vue&type=script&setup=true&lang=js"
export * from "./WebPay.vue?vue&type=script&setup=true&lang=js"

import "./WebPay.vue?vue&type=style&index=0&id=7e81e8a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e81e8a2"]])

export default __exports__